import { Language } from './language';

export class ApplicationSettings {
  applicationCode: string;

  languages: Array<Language>;
  adminApi: string;
  clockURL: string;
  notificationURL: string;
  reportingApiURL: string;
  privacyPolicyUrl: string;
  validateEmail: boolean;
  expirationTimeMinutes: number;
  expirationTimeDays: number;
  checkLogoutIntervalMinutes: number;
  expirationBufferTimeMinutes: number;

  authZeroSettings: AuthZeroSettings;
}

export interface AdminUiConfigResponse {
  applicationCode: string;
  clockURL: string;
  notificationURL: string;
  reportingApiURL: string;
  privacyPolicyUrl: string;
  validateEmail: boolean;
  expirationTimeMinutes: number;
  expirationTimeDays: number;
  checkLogoutIntervalMinutes: number;
  expirationBufferTimeMinutes: number;
  authZeroSettings: AuthZeroSettings;
}

export class AuthZeroSettings {
  useAuthZero: boolean;
  clientID: string;
  domain: string;
  responseType: string;
  redirectUri: string;
}
